import { render, staticRenderFns } from "./GlobalAlert.vue?vue&type=template&id=7db5c9f8&scoped=true&"
import script from "./GlobalAlert.vue?vue&type=script&lang=ts&"
export * from "./GlobalAlert.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalAlert.vue?vue&type=style&index=0&id=7db5c9f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db5c9f8",
  null
  
)

export default component.exports